import { render, staticRenderFns } from "./ListaPreinscritos.vue?vue&type=template&id=4f02a492&"
import script from "./ListaPreinscritos.vue?vue&type=script&lang=js&"
export * from "./ListaPreinscritos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports